var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 120,
    viewBox: "0 0 79 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "figma-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8317 39.621V0H63.5654C67.3825 0 79 5.70811 79 20.482C79 31.7304 68.5451 39.621 62.9015 39.621H39.8317ZM39.169 2.94745e-05V39.621H15.4354C11.6182 39.621 0.000754395 33.9129 0.000754395 19.139C0.000754395 7.89065 10.4557 2.94745e-05 16.0992 2.94745e-05H39.169ZM59.0815 40.1246C44.1448 40.1246 39.8319 52.0445 39.8319 59.5994C39.8319 75.2127 52.445 79.7456 59.0815 79.7456C74.5161 79.7456 78.8865 66.4827 78.8312 59.5994C78.7044 43.8181 65.886 40.1246 59.0815 40.1246ZM14.9367 80.2493H39.1674V102.074C39.1674 116.177 23.0693 122.053 14.9371 119.367C2.98814 115.42 0.0768995 107.111 0 99.7241C-2.56896e-06 86.7969 11.618 80.2493 14.9367 80.2493ZM39.168 79.5777V40.2925H16.0987C10.4553 40.2925 0.000578613 48.1163 0.000578613 59.2693C0.000578613 73.918 11.6178 79.5777 15.4349 79.5777H39.168Z",
    fill: "url(#paint0_linear_38_276)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_276",
    x1: 13.9409,
    y1: 6.04388,
    x2: 67.7446,
    y2: 87.9097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234998,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616884,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/figma-logo.a3febf4cd3b45c5c8c45fb553aed3bf5.svg";
export { ForwardRef as ReactComponent };